/**
 * ADR-172 D5 — the actor is shown as a person, never as a GUID.
 *
 * The API returns, per row:
 *   actor: { id, type, displayName, email, resolved, legacyId, unattributed }
 * `id` is the stored value (a lower-cased username, `system`, `service-<name>`,
 * or — on rows written before ADR-172 — the actor's employee id). The chip
 * shows the name; the stored value is always reachable in the tooltip.
 */
export const LEGACY_ACTOR_NOTE = 'recorded by employee id';

export const isMachineActor = (actor) => actor?.type === 'System';

/** Short label for the chip and the card line. */
export const actorLabel = (actor) => {
  if (!actor) {
    return 'Unknown';
  }
  if (isMachineActor(actor)) {
    return 'Machine';
  }
  if (actor.unattributed) {
    return 'Unattributed actor';
  }
  return actor.displayName || actor.email || actor.id || 'Unknown';
};

/** Full identification for the tooltip and the details panel. */
export const actorDetail = (actor) => {
  if (!actor) {
    return '—';
  }
  if (isMachineActor(actor)) {
    return actor.id ? `Machine · ${actor.id}` : 'Machine';
  }
  if (actor.unattributed) {
    return `No person matches the stored actor ${actor.id || '(empty)'}`;
  }
  const parts = [actor.email || actor.id];
  if (actor.legacyId) {
    parts.push(`${LEGACY_ACTOR_NOTE}: ${actor.id}`);
  }
  if (!actor.resolved) {
    parts.push('not matched to a current consultant');
  }
  return parts.filter(Boolean).join(' · ');
};
